<template>
    <div class="issueItemList">
      <issue-item
        v-for="(issueItem , index) in issueItemList"
        :key="issueItem.num"
        :issueItem="issueItem"
        :issueItemIndex="index"
      />
    </div>
</template>

<script>
    import IssueItem from '@/components/menu/Sunnyfactory/IssueItem'
    export default {
        name: "issue-item-list",
        props: ['issueItemList'],
        components : {
          IssueItem
        },
        data () {
          return {

          }
        },
        created () {

        },
        mounted () {

        },
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueItemList.vue